<template>
  <section class="section-matthias" id="#section-matthias">
    <div class="section-matthias--bg">
      <div class="section-matthias__boxes position-relative">
        <img
          id="steak-blur"
          src="https://ik.imagekit.io/intervi/1-stek-blur_bPe9XgthP.png"
          data-src="https://ik.imagekit.io/intervi/1-stek-blur_bPe9XgthP.png"
          alt
        />
        <img
          id="steak"
          src="https://ik.imagekit.io/intervi/1-stek_fumtOkdu9.png"
          data-src="https://ik.imagekit.io/intervi/1-stek_fumtOkdu9.png"
          alt="Stek wieprzowy w opakownaiu"
        />
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from "@/components/small-components/SectionTitle";
import MainSectionFooter from "@/components/small-components/MainSectionFooter";
import FloatingSocials from "@/components/small-components/FloatingSocials";

export default {
  mounted: function() {
    this.moveSteakBlur();
    this.moveSteak();
  },
  methods: {
    moveSteakBlur: function() {
      $(document).mousemove(function(event) {
        $("#steak-blur").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * 20,
            y: yPos * 20,
            ease: Power1.easeOut
          });
        });
      });
    },
    moveSteak: function() {
      $(document).mousemove(function(event) {
        $("#steak").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * -20,
            y: yPos * -20,
            ease: Power1.easeOut
          });
        });
      });
    }
  },
  // Init components
  components: {
    SectionTitle: SectionTitle,
    FloatingSocials: FloatingSocials
  }
};
</script>
<style lang="scss" scoped>
.section-matthias {
  background: #cfb595;
  &__boxes {
    width: 60%;
    height: 100%;
    margin-left: 40%;
    @media (max-width: 768px) {
      width: 100%;
      height: 70%;
      margin-top: 30%;
      margin-left: 0;
    }
    img {
      // shadow
      &:first-child {
        width: 65%;
        position: absolute;
        top: 20%;
        left: 0;
        @media (max-width: 1200px) {
          top: 35%;
        }
        @media (max-width: 768px) {
          bottom: 13%;
          top: auto;
          left: 4%;
        }
      }
      // box
      &:nth-child(2) {
        width: 75%;
        position: absolute;
        top: 21%;
        left: 2%;
        @media (max-width: 1200px) {
          top: 36%;
        }
        @media (max-width: 768px) {
          bottom: 8%;
          top: auto;
          left: 10%;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/inner-components/ComponentMatthias.vue